import React from "react"
import ApartmentListViewContextProvider from "./src/context/apartments-list-view"
import fetchScripts from "./src/utils/fetchScripts"
import FilterContextProvider from "./src/context/filters"

export const onInitialClientRender = async () => {
  const scripts = await fetchScripts()

  if (scripts?.length > 0) {
    scripts.forEach(script => {
      const scriptElement = document.createElement(
        script.settings.noscript ? "noscript" : "script"
      )
      scriptElement.type = "text/javascript"
      scriptElement.innerHTML = script.data

      if (script.type === "head") {
        document.head.appendChild(scriptElement)
      } else {
        if (script.settings.postBody) {
          document.body.appendChild(scriptElement)
        } else {
          document.body.insertBefore(scriptElement, document.body.firstChild)
        }
      }
    })
  }
}

export const wrapRootElement = ({ element }) => (
    <FilterContextProvider>
      <ApartmentListViewContextProvider>
        {element}
      </ApartmentListViewContextProvider>
    </FilterContextProvider>
)